"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, softwkare
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions andk
 * limitations under the License.kk
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDataLayerScript = exports.withDefaultDataLayer = exports.withDataLayerItem = exports.withMetaSnippet = exports.withMetaForm = exports.withResponsiveVariants = exports.ifViewportIsNot = exports.ifViewportIs = exports.withPageDimensionsContext = exports.usePageDimensionsContext = exports.PageDimensionsProvider = exports.YouTube = exports.YouTubePlayerAPIProvider = exports.ifNotYouTubePlayerAPILoaded = exports.ifYouTubePlayerAPILoaded = exports.withYouTubePlayerAPI = exports.useYouTubePlayerAPI = exports.withYouTubeFormHeader = exports.withYouTubeFormSrcSnippet = exports.withYouTubePlayerTransformer = exports.withYouTubePlayerSettings = exports.asBodilessYouTube = exports.asBaseBodilessYouTube = exports.useIframeBodilessOptions = exports.withIframeFormSrcSnippet = exports.withIframeFormHeightSnippet = exports.withIframeFormHeader = exports.withoutPointerEvents = exports.asBodilessIframe = exports.asBaseBodilessIframe = exports.useTagsAccessors = exports.withFilterByTags = exports.asTaggableItem = exports.withTagButton = exports.withEditPlaceholder = exports.asBodilessHelmet = exports.withMetaHtml = exports.withMetaStatic = exports.withTitle = exports.withMeta = exports.asEditable = exports.withPlaceholder = exports.withToggleButton = exports.withToggleTo = exports.withToggle = exports.withListTitle = exports.withDeleteSublistOnUnwrap = exports.withSublist = exports.withBasicSublist = exports.asBasicSublist = exports.asEditableList = exports.List = exports.withLinkToggle = exports.NodeViewer = exports.Editable = exports.withImagePlaceholder = exports.ImageDropZone = exports.asBodilessImage = exports.Image = exports.withBodilessLinkToggle = void 0;

var Editable_1 = __importStar(require("./Editable"));

exports.Editable = Editable_1.default;
Object.defineProperty(exports, "withPlaceholder", {
  enumerable: true,
  get: function get() {
    return Editable_1.withPlaceholder;
  }
});
Object.defineProperty(exports, "asEditable", {
  enumerable: true,
  get: function get() {
    return Editable_1.asEditable;
  }
});

var Image_1 = __importStar(require("./Image"));

exports.Image = Image_1.default;
Object.defineProperty(exports, "asBodilessImage", {
  enumerable: true,
  get: function get() {
    return Image_1.asBodilessImage;
  }
});
Object.defineProperty(exports, "withImagePlaceholder", {
  enumerable: true,
  get: function get() {
    return Image_1.withImagePlaceholder;
  }
});
Object.defineProperty(exports, "ImageDropZone", {
  enumerable: true,
  get: function get() {
    return Image_1.DropZonePlugin;
  }
});

var NodeViewer_1 = __importDefault(require("./NodeViewer"));

exports.NodeViewer = NodeViewer_1.default;

var LinkToggle_1 = __importDefault(require("./LinkToggle"));

exports.withLinkToggle = LinkToggle_1.default;

var List_DEPRECATED_1 = __importDefault(require("./List_DEPRECATED"));

exports.List = List_DEPRECATED_1.default;

var asTaggableItem_1 = __importDefault(require("./Taggable/asTaggableItem"));

exports.asTaggableItem = asTaggableItem_1.default;

var withListTitle_1 = __importDefault(require("./List_DEPRECATED/withListTitle"));

exports.withListTitle = withListTitle_1.default;

var asEditableList_1 = __importDefault(require("./List_DEPRECATED/asEditableList"));

exports.asEditableList = asEditableList_1.default;

var asBasicSublist_1 = __importDefault(require("./List_DEPRECATED/asBasicSublist"));

exports.asBasicSublist = asBasicSublist_1.default;

var withSublist_1 = __importStar(require("./List_DEPRECATED/withSublist"));

exports.withSublist = withSublist_1.default;
Object.defineProperty(exports, "withBasicSublist", {
  enumerable: true,
  get: function get() {
    return withSublist_1.withBasicSublist;
  }
});

var withDeleteSublistOnUnwrap_1 = __importDefault(require("./List_DEPRECATED/withDeleteSublistOnUnwrap"));

exports.withDeleteSublistOnUnwrap = withDeleteSublistOnUnwrap_1.default;

var Meta_1 = require("./Meta/Meta");

Object.defineProperty(exports, "withMeta", {
  enumerable: true,
  get: function get() {
    return Meta_1.withMeta;
  }
});
Object.defineProperty(exports, "withMetaStatic", {
  enumerable: true,
  get: function get() {
    return Meta_1.withMetaStatic;
  }
});
Object.defineProperty(exports, "withMetaHtml", {
  enumerable: true,
  get: function get() {
    return Meta_1.withMetaHtml;
  }
});
Object.defineProperty(exports, "withTitle", {
  enumerable: true,
  get: function get() {
    return Meta_1.withTitle;
  }
});

var withMetaForm_1 = __importStar(require("./Meta/withMetaForm"));

exports.withMetaForm = withMetaForm_1.default;
Object.defineProperty(exports, "withMetaSnippet", {
  enumerable: true,
  get: function get() {
    return withMetaForm_1.withMetaSnippet;
  }
});

var Helmet_1 = __importDefault(require("./Helmet/Helmet"));

exports.asBodilessHelmet = Helmet_1.default;

var gtm_1 = __importStar(require("./GTM/gtm"));

exports.withDataLayerItem = gtm_1.default;
Object.defineProperty(exports, "withDefaultDataLayer", {
  enumerable: true,
  get: function get() {
    return gtm_1.withDefaultDataLayer;
  }
});
Object.defineProperty(exports, "withDataLayerScript", {
  enumerable: true,
  get: function get() {
    return gtm_1.withDataLayerScript;
  }
});

var Toggle_1 = require("./Toggle");

Object.defineProperty(exports, "withToggle", {
  enumerable: true,
  get: function get() {
    return Toggle_1.withToggle;
  }
});
Object.defineProperty(exports, "withToggleTo", {
  enumerable: true,
  get: function get() {
    return Toggle_1.withToggleTo;
  }
});
Object.defineProperty(exports, "withToggleButton", {
  enumerable: true,
  get: function get() {
    return Toggle_1.withToggleButton;
  }
});

var Placeholder_1 = __importDefault(require("./Placeholder"));

exports.withEditPlaceholder = Placeholder_1.default;

var TagButton_1 = require("./TagButton");

Object.defineProperty(exports, "withTagButton", {
  enumerable: true,
  get: function get() {
    return TagButton_1.withTagButton;
  }
});
Object.defineProperty(exports, "useTagsAccessors", {
  enumerable: true,
  get: function get() {
    return TagButton_1.useTagsAccessors;
  }
});

var withFilterByTags_1 = __importDefault(require("./withFilterByTags"));

exports.withFilterByTags = withFilterByTags_1.default;

var Iframe_1 = __importStar(require("./Iframe"));

exports.asBodilessIframe = Iframe_1.default;
Object.defineProperty(exports, "asBaseBodilessIframe", {
  enumerable: true,
  get: function get() {
    return Iframe_1.asBaseBodilessIframe;
  }
});
Object.defineProperty(exports, "withoutPointerEvents", {
  enumerable: true,
  get: function get() {
    return Iframe_1.withoutPointerEvents;
  }
});
Object.defineProperty(exports, "withIframeFormHeader", {
  enumerable: true,
  get: function get() {
    return Iframe_1.withIframeFormHeader;
  }
});
Object.defineProperty(exports, "withIframeFormHeightSnippet", {
  enumerable: true,
  get: function get() {
    return Iframe_1.withIframeFormHeightSnippet;
  }
});
Object.defineProperty(exports, "withIframeFormSrcSnippet", {
  enumerable: true,
  get: function get() {
    return Iframe_1.withIframeFormSrcSnippet;
  }
});
Object.defineProperty(exports, "useIframeBodilessOptions", {
  enumerable: true,
  get: function get() {
    return Iframe_1.useIframeBodilessOptions;
  }
});

var YouTube_1 = __importStar(require("./YouTube"));

exports.YouTube = YouTube_1.default;
Object.defineProperty(exports, "asBaseBodilessYouTube", {
  enumerable: true,
  get: function get() {
    return YouTube_1.asBaseBodilessYouTube;
  }
});
Object.defineProperty(exports, "asBodilessYouTube", {
  enumerable: true,
  get: function get() {
    return YouTube_1.asBodilessYouTube;
  }
});
Object.defineProperty(exports, "withYouTubeFormHeader", {
  enumerable: true,
  get: function get() {
    return YouTube_1.withYouTubeFormHeader;
  }
});
Object.defineProperty(exports, "withYouTubePlayerSettings", {
  enumerable: true,
  get: function get() {
    return YouTube_1.withYouTubePlayerSettings;
  }
});
Object.defineProperty(exports, "withYouTubeFormSrcSnippet", {
  enumerable: true,
  get: function get() {
    return YouTube_1.withYouTubeFormSrcSnippet;
  }
});
Object.defineProperty(exports, "withYouTubePlayerTransformer", {
  enumerable: true,
  get: function get() {
    return YouTube_1.withYouTubePlayerTransformer;
  }
});
Object.defineProperty(exports, "useYouTubePlayerAPI", {
  enumerable: true,
  get: function get() {
    return YouTube_1.useYouTubePlayerAPI;
  }
});
Object.defineProperty(exports, "withYouTubePlayerAPI", {
  enumerable: true,
  get: function get() {
    return YouTube_1.withYouTubePlayerAPI;
  }
});
Object.defineProperty(exports, "ifYouTubePlayerAPILoaded", {
  enumerable: true,
  get: function get() {
    return YouTube_1.ifYouTubePlayerAPILoaded;
  }
});
Object.defineProperty(exports, "ifNotYouTubePlayerAPILoaded", {
  enumerable: true,
  get: function get() {
    return YouTube_1.ifNotYouTubePlayerAPILoaded;
  }
});
Object.defineProperty(exports, "YouTubePlayerAPIProvider", {
  enumerable: true,
  get: function get() {
    return YouTube_1.YouTubePlayerAPIProvider;
  }
});

var PageDimensionsProvider_1 = __importStar(require("./PageDimensionsProvider"));

exports.PageDimensionsProvider = PageDimensionsProvider_1.default;
Object.defineProperty(exports, "usePageDimensionsContext", {
  enumerable: true,
  get: function get() {
    return PageDimensionsProvider_1.usePageDimensionsContext;
  }
});
Object.defineProperty(exports, "withPageDimensionsContext", {
  enumerable: true,
  get: function get() {
    return PageDimensionsProvider_1.withPageDimensionsContext;
  }
});

var withResponsiveToggle_1 = require("./withResponsiveToggle");

Object.defineProperty(exports, "ifViewportIs", {
  enumerable: true,
  get: function get() {
    return withResponsiveToggle_1.ifViewportIs;
  }
});
Object.defineProperty(exports, "ifViewportIsNot", {
  enumerable: true,
  get: function get() {
    return withResponsiveToggle_1.ifViewportIsNot;
  }
});

var withResponsiveVariants_1 = __importDefault(require("./withResponsiveVariants"));

exports.withResponsiveVariants = withResponsiveVariants_1.default;

var withBodilessLinkToggle_1 = __importDefault(require("./withBodilessLinkToggle"));

exports.withBodilessLinkToggle = withBodilessLinkToggle_1.default;

__exportStar(require("./Chameleon/index"), exports);

__exportStar(require("./List"), exports);

__exportStar(require("./Link"), exports);

__exportStar(require("./Breadcrumbs"), exports);